import React from "react";

function StylesPage() {
  return <div>StylesPage</div>;
}

export default StylesPage;
